import { DatatablePaginationFilters } from "../../../hooks/useGuiConfState";
import { SortOrder } from "../../../hooks/useTableSort";
import { ServiceStatus, ServiceType } from "../../../models/service";
import { DEFAULT_DESTINATION_TIME_ZONE, getDateMoment } from "../../../helpers/dateHelper";

export type ServiceFiltersType = DatatablePaginationFilters & {
    dateFrom: Date | null;
    dateTo: Date | null;
    type: ServiceType | undefined;
    status: ServiceStatus[];
    shipId: string;
    order: SortOrder;
};

export function buildServicesSearchPayload(
    filters: ServiceFiltersType,
    timeZone = DEFAULT_DESTINATION_TIME_ZONE,
) {
    return {
        textSearch: "",
        offset: filters.page * filters.rowsPerPage,
        limit: filters.rowsPerPage,
        order: filters.order,
        columns: {},
        filter: buildServicesSearchPayloadFilters(filters, timeZone),
    };
}

function buildServicesSearchPayloadFilters(filters: ServiceFiltersType, timeZone: string) {
    const { dateFrom, dateTo, type, status, shipId } = filters;

    const filterArray: object[] = [];

    if (dateFrom) {
        const startDate = getDateMoment(dateFrom, { timeZone }).startOf("day");
        filterArray.push({ startDateTime: { $gte: startDate.valueOf() } });
    }

    if (dateTo) {
        const endDate = getDateMoment(dateTo, { timeZone }).endOf("day");
        filterArray.push({ startDateTime: { $lte: endDate.valueOf() } });
    }

    if (type) {
        filterArray.push({ type: type });
    }

    if (status?.length > 0) {
        const serviceStatusFilterArray: object[] = [];
        status.forEach(st => serviceStatusFilterArray.push({ status: st.toString() }));
        filterArray.push({ $or: serviceStatusFilterArray });
    }

    if (shipId) {
        filterArray.push({ shipId: shipId });
    }

    return { $and: filterArray };
}
